import React from 'react';
import PropTypes from 'prop-types';

import PaymentMethodItem from 'components/ClientProfile/Payment/Deposit/PaymentMethodItem';

const DepositListItem = ({ methodAsLink, payment, to }) => (
  <PaymentMethodItem methodAsLink={methodAsLink} paymentMethod={payment} to={to} />
);

DepositListItem.propTypes = {
  methodAsLink: PropTypes.bool,
  payment: PropTypes.object.isRequired,
  to: PropTypes.string,
};

export default DepositListItem;
